import React from 'react';
import RadioInput from '../../components/RadioButton';
import Button from '../../components/Button';
import { useNavigate } from 'react-router-dom';
import { markSuicideAttemptWhen } from '../../core/actions';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../core/app_state_config';
import './suicide-attempt-when.scss';

const SuicideAttempt: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const form = useSelector((state: RootState) => state.app).suicide_attempt_when;
    const [response, setResponse] = React.useState<any>(null);

    React.useEffect(() => {
        setResponse(form);
        return;
    }, [form]);

    function onChanged(value: any) {
        setResponse(value);
    }

    function onSubmitted() {
        dispatch(markSuicideAttemptWhen(response));
        if (response === 'within_the_last_twelve_months') {
            navigate('/vague-hurting', { replace: true });
        } else {
            navigate('/result', { replace: true });
        }
    }
    return (
        <div className="suicide-attempt-when">
            <h1 className="suicide-attempt-when__title">If it's okay to share, when did you last face such a challenging moment?</h1>
            <h4 className="opening-questions__subtitle">Knowing this helps us to better support you.</h4>
            <RadioInput id={'within_the_last_twelve_months'} label={'Within the last 12 months'} groupValue={response} onChange={onChanged} value={'within_the_last_twelve_months'} />
            <RadioInput id={'between_one_and_five_years_ago'} label={'1-5 years ago'} groupValue={response} onChange={onChanged} value={'between_one_and_five_years_ago'} />
            <RadioInput id={'between_six_and_ten_years_ago'} label={'6-10 years ago'} groupValue={response} onChange={onChanged} value={'between_six_and_ten_years_ago'} />
            <RadioInput id={'more_than_ten_years_ago'} label={'More than 10 years ago'} groupValue={response} onChange={onChanged} value={'more_than_ten_years_ago'} />
            <div style={{ marginTop: 16 }}>
                <Button type='primary' onPressed={onSubmitted} disabled={!response}>
                    {'Continue'}
                </Button>
            </div>
        </div>
    );
}

export default SuicideAttempt;
